import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,

	state: {
		lstInf: [],
		inf: {},
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
		infsubclas: "",
		inffm1id: 0
	},

	getters: {
		getUpdate: state => state.update,

		getInf(state) {
			return {
				inffm1id: state.inffm1id,
				infsubclas: state.infsubclas
			}
		},

		getInfid: state => state.inf?.inffm1id,

		getSearch: state => state.search,
		getItemsPerPage: state => state.itemsPerPage,

	},

	mutations: {
		set(state, inf) {
			state.inf = inf
			if (inf) state.update = true
		},

		setInfList(state, inf) {
			state.lstInf = inf
			if (inf) state.update = true
		},

		initForm(state) {
			state.insert = false
			state.update = false
			state.inf = {}
		},

		setParamsDataTable(state, payload) {
			state.lstInf = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},

		setLoading: (state, val) => (state.loading = val),
		setInf: (state, val) => (state.inf = val),
		setHasNext: (state, val) => (state.hasNext = val),
		setSearch: (state, val) => (state.search = val),
		setLastUpdatedRegister: (state, val) => (state.lastUpdatedRegister = val),
	},

	actions: {
		initForm({ commit }) {
			commit("initForm")
		},

        async findBySubClass({ commit, dispatch }, incsubclas) {
			await this._vm.$axios
				.get(`/OryxPlace/SubClassAnalysis/FindBySubClass/${incsubclas}`)
				.then(response => {
					let inf = Utils.ValidateAxiosResponse(response.data)
					if(inf){
						commit("setInfList", inf)
					}
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})

		},

		async save({ getters, dispatch }) {
			if (getters.getUpdate) return await dispatch("update")
			return await dispatch("insert")
		},

		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.post("/OryxPlace/SubClassAnalysis/Insert", getters.getInf)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setInf", null)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
			return payload
		},

		async update({ commit, dispatch }, inf) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)

			let payload = await this._vm.$axios
				.put("/OryxPlace/SubClassAnalysis/Update", inf)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
			return payload
		},

		async deleteBySubClass({dispatch }, incsubclas) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)

			await this._vm.$axios
				.delete(`/OryxPlace/SubClassAnalysis/DeleteBySubClass/${incsubclas}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
		},

		async deleteBySubClassSupply({ dispatch }, { infsubclas, inffm1id }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/OryxPlace/SubClassAnalysis/DeleteBySubClassAnalysis/${infsubclas}/${inffm1id}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
		},

		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)

			await this._vm.$axios
				.delete(`/OryxPlace/SubClassAnalysis/Delete/${getters.getInfid}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})

			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false }, { root: true })
		},
	},
}